import styled from 'styled-components';
import { Input } from '../Input/Input.js';

const StyledInput = styled(Input) `
  box-sizing: border-box;
  height: 48px;
  width: 40px;
  text-align: center;

  &::-webkit-inner-spin-button,
  -webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

export { StyledInput };
